export const ONE_DECIMAL_OPTION = {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
};

export const TWO_DECIMAL_OPTION = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};
